"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectionClasses = void 0;
exports.getDWSDateFromTimestamp = getDWSDateFromTimestamp;
exports.handleDwsSelectAll = handleDwsSelectAll;
exports.updateDwsSelectionStyles = updateDwsSelectionStyles;
exports.updateDwsSelectAllCopyCutStyle = updateDwsSelectAllCopyCutStyle;
exports.clearDwsSelectionStyles = clearDwsSelectionStyles;
exports.disablePointerEventsForSlots = disablePointerEventsForSlots;
exports.initDwsCellEdit = initDwsCellEdit;
const summary_lib_1 = require("../js/summary_lib");
const tableEditMode_1 = require("../summaryTable/tableEditMode");
const common_1 = require("../js/common");
const common_2 = require("../common/common");
const timeZones_1 = __importDefault(require("../common/timeZones"));
exports.selectionClasses = {
    SELECTED_CELL: 'selected-cell',
    MULTI_SELECTED_CELL: 'multi-selected-cell',
    DASHED: 'dashed',
    DASHED_CUT: 'dashed-cut',
    TOP_SELECTED: 'is-top-selected',
    BOTTOM_SELECTED: 'is-bottom-selected',
    LEFT_SELECTED: 'is-left-selected',
    RIGHT_SELECTED: 'is-right-selected',
};
function getDWSDateFromTimestamp(timestamp) {
    if (!timestamp) {
        return "";
    }
    return (0, common_2.yearMonthDateString)((0, common_1.dateFromSecondsTimestamp)(Number(timestamp)), timeZones_1.default.ASIA_TOKYO);
}
function getDwsCellInfoFromTarget(target) {
    if (!(target instanceof Element)) {
        return null;
    }
    const contextTarget = target.closest('.grid-body-time-cell[data-user][data-timestamp]');
    if (!contextTarget) {
        return null;
    }
    const userId = contextTarget.dataset.user || "";
    const timestamp = contextTarget.dataset.timestamp || "";
    let date = contextTarget.dataset.date || "";
    if (!date && timestamp) {
        date = getDWSDateFromTimestamp(timestamp);
    }
    return {
        userId,
        date,
        timestamp,
        rowIndex: Number(contextTarget.dataset.rowIndex),
        colIndex: Number(contextTarget.dataset.colIndex),
    };
}
function getDwsSlotIdsForCell(userId, timestamp) {
    if (!userId || !timestamp) {
        return [];
    }
    const cellStartTimestamp = Number(timestamp);
    const cellEndTimestamp = cellStartTimestamp + 900; // 15 min
    const slotIds = [];
    document
        .querySelectorAll(`.slots-overlay[data-user="${userId}"] .slot.draggable[data-id]`)
        .forEach(slot => {
        const from = Number(slot.dataset.from || 0);
        const to = Number(slot.dataset.to || 0);
        if (!from || !to) {
            return;
        }
        if (!(from < cellEndTimestamp && to > cellStartTimestamp)) {
            return;
        }
        const slotId = slot.dataset.id;
        if (slotId) {
            slotIds.push(slotId);
        }
    });
    return slotIds;
}
function getDwsCellByRowCol(rowIndex, colIndex) {
    return document.querySelector(`.grid-body-time-cell[data-row-index="${rowIndex}"][data-col-index="${colIndex}"]`);
}
function getDwsSelectedRectCells(startCell, endCell) {
    if (!startCell || !endCell || startCell.rowIndex < 0 || startCell.colIndex < 0 || endCell.rowIndex < 0 || endCell.colIndex < 0) {
        return [];
    }
    const minRow = Math.min(startCell.rowIndex, endCell.rowIndex);
    const maxRow = Math.max(startCell.rowIndex, endCell.rowIndex);
    const minCol = Math.min(startCell.colIndex, endCell.colIndex);
    const maxCol = Math.max(startCell.colIndex, endCell.colIndex);
    const selectedCells = [];
    // Query cells within the selected rectangle
    for (let rowIndex = minRow; rowIndex <= maxRow; rowIndex++) {
        for (let colIndex = minCol; colIndex <= maxCol; colIndex++) {
            const cell = getDwsCellByRowCol(rowIndex, colIndex);
            if (!cell) {
                continue;
            }
            const timestamp = cell.dataset.timestamp || "";
            selectedCells.push({
                userId: cell.dataset.user || "",
                date: getDWSDateFromTimestamp(timestamp),
                timestamp,
            });
        }
    }
    return selectedCells;
}
function selectDwsCellSelection(startCell, endCell) {
    if (!startCell || !startCell.userId || !startCell.date) {
        return;
    }
    (0, tableEditMode_1.resetSelectCopyOrCut)();
    tableEditMode_1.cellEditMode.copyCellData = {};
    const selectedCells = getDwsSelectedRectCells(startCell, endCell);
    selectedCells.forEach(cell => {
        (0, tableEditMode_1.addCellData)(cell.userId, cell.timestamp);
        const slotIds = getDwsSlotIdsForCell(cell.userId, cell.timestamp);
        updateSelectedCellData(cell, slotIds);
    });
    const firstCell = selectedCells[0] || startCell;
    const firstCellSlotIds = getDwsSlotIdsForCell(firstCell.userId, firstCell.timestamp);
    (0, tableEditMode_1.setSelectedCell)({
        id: `dws-${firstCell.userId}_${firstCell.timestamp}`,
        userId: firstCell.userId,
        date: firstCell.date,
        timestamp: firstCell.timestamp,
        slotIds: firstCellSlotIds,
    });
    updateDwsSelectionStyles();
}
let dwsSelectionStart = null;
let dwsSelectionMouseDown = false;
function handleDwsSelectionMouseDown(event) {
    if (!tableEditMode_1.cellEditMode.isOn || event.button !== 0) {
        return;
    }
    if (!(event.target instanceof Element)) {
        return;
    }
    const cellInfo = getDwsCellInfoFromTarget(event.target);
    if (!cellInfo || !cellInfo.userId || !cellInfo.timestamp) {
        return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    dwsSelectionStart = cellInfo;
    dwsSelectionMouseDown = true;
    tableEditMode_1.cellEditMode.isDragging = false;
    const isCtrlOrCmd = event.ctrlKey || event.metaKey;
    if (isCtrlOrCmd) {
        let slotIds = [];
        const cellKey = cellInfo.timestamp;
        const alreadySelected = Boolean(tableEditMode_1.cellEditMode.copyCellData?.[cellInfo.userId]?.[cellKey]);
        if (alreadySelected) {
            (0, tableEditMode_1.removeCellData)(cellInfo.userId, cellKey);
        }
        else {
            (0, tableEditMode_1.addCellData)(cellInfo.userId, cellKey);
            slotIds = getDwsSlotIdsForCell(cellInfo.userId, cellInfo.timestamp);
            updateSelectedCellData(cellInfo, slotIds);
        }
        (0, tableEditMode_1.setSelectedCell)({
            id: `dws-${cellInfo.userId}_${cellKey}`,
            userId: cellInfo.userId,
            date: cellInfo.date,
            timestamp: cellInfo.timestamp,
            slotIds,
        });
        updateDwsSelectionStyles();
        return;
    }
    selectDwsCellSelection(cellInfo, cellInfo);
}
function handleDwsSelectionMouseMove(event) {
    if (!tableEditMode_1.cellEditMode.isOn || !dwsSelectionMouseDown || !dwsSelectionStart) {
        return;
    }
    if (!(event.target instanceof Element)) {
        return;
    }
    const cellInfo = getDwsCellInfoFromTarget(event.target);
    if (!cellInfo || !cellInfo.userId || !cellInfo.date) {
        return;
    }
    if (cellInfo.rowIndex !== dwsSelectionStart.rowIndex || cellInfo.colIndex !== dwsSelectionStart.colIndex) {
        tableEditMode_1.cellEditMode.isDragging = true;
        selectDwsCellSelection(dwsSelectionStart, cellInfo);
    }
}
function handleDwsSelectionMouseUp(event) {
    if (!tableEditMode_1.cellEditMode.isOn || !dwsSelectionMouseDown) {
        return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    dwsSelectionMouseDown = false;
    dwsSelectionStart = null;
}
function handleDwsBlockDefaultClick(event) {
    if (!tableEditMode_1.cellEditMode.isOn) {
        return;
    }
    const cellInfo = getDwsCellInfoFromTarget(event.target);
    if (!cellInfo || !cellInfo.userId || !cellInfo.date) {
        return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    (0, tableEditMode_1.closeCellEditMenu)();
}
function updateSelectedCellData(cell, slotIds) {
    const selectedCell = tableEditMode_1.cellEditMode.copyCellData[cell.userId]?.[cell.timestamp];
    if (!selectedCell) {
        return;
    }
    selectedCell.slotIds = slotIds;
}
function getDwsCellElement(userId, timestamp) {
    return document.querySelector(`.grid-body-time-cell[data-user="${userId}"][data-timestamp="${timestamp}"]`);
}
function getSelectedDwsCells() {
    const selectedCells = [];
    Object.entries(tableEditMode_1.cellEditMode.copyCellData || {}).forEach(([userId, cells]) => {
        Object.entries(cells).forEach(([timestamp, selectedState]) => {
            const cell = getDwsCellElement(userId, timestamp);
            if (!cell) {
                return;
            }
            selectedCells.push({
                cell,
                rowIndex: Number(cell.dataset.rowIndex),
                colIndex: Number(cell.dataset.colIndex),
                selectedState,
            });
        });
    });
    return selectedCells;
}
function handleDwsSelectAll() {
    const cells = document.querySelectorAll('.grid-body-time-cell[data-user][data-timestamp]');
    cells.forEach(cell => {
        const userId = cell.dataset.user || "";
        const timestamp = cell.dataset.timestamp || "";
        if (!userId || !timestamp) {
            return;
        }
        (0, tableEditMode_1.addCellData)(userId, timestamp);
    });
    const slotIds = getAllDwsSlotIds();
    const firstCell = cells[0];
    if (firstCell) {
        const userId = firstCell.dataset.user || "";
        const timestamp = firstCell.dataset.timestamp || "";
        updateSelectedCellData({
            userId,
            timestamp,
            date: getDWSDateFromTimestamp(timestamp),
        }, slotIds);
    }
    clearDwsSelectedCellStyle();
    clearDwsSelectionStyles();
    document.querySelector('.grid-container')?.classList.add('dws-all-selected');
}
function getAllDwsSlotIds() {
    const slotIds = new Set();
    document
        .querySelectorAll('.slot.draggable[data-id]')
        .forEach(slot => {
        const slotId = slot.dataset.id;
        if (!slotId) {
            return;
        }
        slotIds.add(slotId);
    });
    return [...slotIds];
}
function updateDwsSelectionStyles() {
    clearDwsSelectionStyles();
    clearDwsSelectedCellStyle();
    const selectedCellTimestamp = String(tableEditMode_1.cellEditMode.selectedCell.timestamp || "");
    const selectedCell = getDwsCellElement(tableEditMode_1.cellEditMode.selectedCell.userId, selectedCellTimestamp);
    if (selectedCell) {
        selectedCell.classList.add(exports.selectionClasses.SELECTED_CELL);
    }
    const selectedCells = getSelectedDwsCells();
    if (selectedCells.length === 0) {
        return;
    }
    const minRow = Math.min(...selectedCells.map(({ rowIndex }) => rowIndex));
    const maxRow = Math.max(...selectedCells.map(({ rowIndex }) => rowIndex));
    const minCol = Math.min(...selectedCells.map(({ colIndex }) => colIndex));
    const maxCol = Math.max(...selectedCells.map(({ colIndex }) => colIndex));
    selectedCells.forEach(({ cell, rowIndex, colIndex, selectedState }) => {
        cell.classList.add(exports.selectionClasses.MULTI_SELECTED_CELL);
        cell.classList.remove(exports.selectionClasses.SELECTED_CELL);
        if (selectedState.isSelectedForCopy) {
            cell.classList.add(exports.selectionClasses.DASHED);
        }
        if (selectedState.isSelectedForCut || selectedState.isSelectedForDelete) {
            cell.classList.add(exports.selectionClasses.DASHED_CUT);
        }
        if (rowIndex > minRow) {
            cell.classList.add(exports.selectionClasses.TOP_SELECTED);
        }
        if (rowIndex < maxRow) {
            cell.classList.add(exports.selectionClasses.BOTTOM_SELECTED);
        }
        if (colIndex > minCol) {
            cell.classList.add(exports.selectionClasses.LEFT_SELECTED);
        }
        if (colIndex < maxCol) {
            cell.classList.add(exports.selectionClasses.RIGHT_SELECTED);
        }
    });
}
function updateDwsSelectAllCopyCutStyle(isCopy) {
    const cells = document.querySelectorAll('.grid-body-time-cell[data-user][data-timestamp]');
    if (!cells.length) {
        return;
    }
    let minRow = Infinity;
    let maxRow = -Infinity;
    let minCol = Infinity;
    let maxCol = -Infinity;
    cells.forEach(cell => {
        const rowIndex = Number(cell.dataset.rowIndex);
        const colIndex = Number(cell.dataset.colIndex);
        minRow = Math.min(minRow, rowIndex);
        maxRow = Math.max(maxRow, rowIndex);
        minCol = Math.min(minCol, colIndex);
        maxCol = Math.max(maxCol, colIndex);
    });
    cells.forEach(cell => {
        const rowIndex = Number(cell.dataset.rowIndex);
        const colIndex = Number(cell.dataset.colIndex);
        cell.classList.add(exports.selectionClasses.MULTI_SELECTED_CELL);
        cell.classList.toggle(exports.selectionClasses.DASHED, isCopy);
        cell.classList.toggle(exports.selectionClasses.DASHED_CUT, !isCopy);
        if (rowIndex > minRow) {
            cell.classList.add(exports.selectionClasses.TOP_SELECTED);
        }
        if (rowIndex < maxRow) {
            cell.classList.add(exports.selectionClasses.BOTTOM_SELECTED);
        }
        if (colIndex > minCol) {
            cell.classList.add(exports.selectionClasses.LEFT_SELECTED);
        }
        if (colIndex < maxCol) {
            cell.classList.add(exports.selectionClasses.RIGHT_SELECTED);
        }
    });
}
function updateDwsSelectedCellStyle(cell) {
    clearDwsSelectedCellStyle();
    if (cell.classList.contains(exports.selectionClasses.MULTI_SELECTED_CELL) ||
        document.querySelector('.grid-container')?.classList.contains('dws-all-selected')) {
        return;
    }
    cell.classList.add(exports.selectionClasses.SELECTED_CELL);
}
function clearDwsSelectedCellStyle() {
    document
        .querySelectorAll(`.grid-body-time-cell.${exports.selectionClasses.SELECTED_CELL}`)
        .forEach(cell => {
        cell.classList.remove(exports.selectionClasses.SELECTED_CELL);
    });
}
function clearDwsSelectionStyles() {
    document.querySelector('.grid-container')?.classList.remove('dws-all-selected');
    document
        .querySelectorAll(`.grid-body-time-cell.${exports.selectionClasses.MULTI_SELECTED_CELL}, .grid-body-time-cell.${exports.selectionClasses.DASHED}, .grid-body-time-cell.${exports.selectionClasses.DASHED_CUT}`)
        .forEach(cell => {
        cell.classList.remove(exports.selectionClasses.MULTI_SELECTED_CELL, exports.selectionClasses.DASHED, exports.selectionClasses.DASHED_CUT, exports.selectionClasses.TOP_SELECTED, exports.selectionClasses.BOTTOM_SELECTED, exports.selectionClasses.LEFT_SELECTED, exports.selectionClasses.RIGHT_SELECTED);
    });
}
function handleCellEditModeChanged(event) {
    const isOn = event.detail?.isOn;
    const slots = document.querySelectorAll('.slot');
    slots.forEach(slot => {
        slot.classList.toggle('pointer-event-none', Boolean(isOn));
    });
    if (!isOn) {
        clearDwsSelectionStyles();
        clearDwsSelectedCellStyle();
    }
}
function disablePointerEventsForSlots(slots) {
    slots.forEach(slot => {
        document.getElementById(`slot-${slot.ID}`)?.classList.add('pointer-event-none');
    });
}
function handleDwsContextMenu(event, canEdit) {
    const target = event.target;
    if (!(target instanceof Element)) {
        return;
    }
    const contextTarget = target.closest('.grid-body-time-cell[data-user][data-timestamp]');
    if (!contextTarget || !canEdit) {
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    const userId = contextTarget.dataset.user || "";
    const timestamp = contextTarget.dataset.timestamp || "";
    const date = contextTarget.dataset.date || getDWSDateFromTimestamp(timestamp);
    if (!userId || !date) {
        return;
    }
    (0, tableEditMode_1.setSelectedCell)({
        id: contextTarget.id || "",
        userId,
        date,
        timestamp,
        slotIds: [],
    });
    if (!tableEditMode_1.cellEditMode.isOn) {
        (0, tableEditMode_1.initCellEdit)();
    }
    (0, tableEditMode_1.handleRightClickCell)(event);
    updateDwsSelectedCellStyle(contextTarget);
}
function initDwsCellEdit(canEdit, viewType) {
    (0, summary_lib_1.mountCellEditMenuApp)(viewType);
    document.addEventListener('contextmenu', event => handleDwsContextMenu(event, canEdit), true);
    document.addEventListener('mousedown', handleDwsSelectionMouseDown, true);
    document.addEventListener('mousemove', handleDwsSelectionMouseMove, true);
    document.addEventListener('mouseup', handleDwsSelectionMouseUp, true);
    document.addEventListener('click', handleDwsBlockDefaultClick, true);
    window.addEventListener('cellEditModeChanged', handleCellEditModeChanged);
    tableEditMode_1.cellEditMode.isDWS = true;
}
